import React from "react";

/* eslint-disable max-len */
export default function UploadVideoIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <defs>
                <clipPath id="a">
                    <path
                        data-name="\u9577\u65B9\u5F62 1716"
                        fill="#9c9c9c"
                        d="M0 0H29.605V22.016H0z"
                    />
                </clipPath>
            </defs>
            <g data-name="\u30B0\u30EB\u30FC\u30D7 556">
                <g data-name="\u30B0\u30EB\u30FC\u30D7 543">
                    <g
                        data-name="\u30B0\u30EB\u30FC\u30D7 542"
                        transform="translate(-40 -95) translate(40.2 122) translate(0 -23)"
                        clipPath="url(#a)"
                        fill="#9c9c9c"
                    >
                        <path
                            data-name="\u30D1\u30B9 8160"
                            d="M25.9 22.016v-4.551a1.01 1.01 0 011.01-1.009h2.7l-6.634-7.639-6.629 7.639h2.7a1.01 1.01 0 011.01 1.009v4.551z"
                        />
                        <path
                            data-name="\u30D1\u30B9 8161"
                            d="M22.213 6.615a.94.94 0 01.346-.248V1.623a.581.581 0 000-.059A1.594 1.594 0 0020.936 0H1.564A1.594 1.594 0 000 1.623v13.53a1.594 1.594 0 001.623 1.564h11.824zm-6.233-4.13a.24.24 0 01.24-.24h3.521a.239.239 0 01.239.24v1.52a.239.239 0 01-.239.24H16.22a.24.24 0 01-.24-.24zm-9.4 11.821a.239.239 0 01-.239.239H2.82a.24.24 0 01-.24-.239v-1.522a.24.24 0 01.24-.239h3.521a.239.239 0 01.239.239zm0-10.3a.239.239 0 01-.239.24H2.82a.24.24 0 01-.24-.24V2.485a.24.24 0 01.24-.24h3.521a.239.239 0 01.239.24zm6.7 10.3a.24.24 0 01-.24.239H9.52a.239.239 0 01-.239-.239v-1.522a.239.239 0 01.239-.239h3.521a.24.24 0 01.24.239zm-.24-10.061H9.52a.239.239 0 01-.239-.24v-1.52a.239.239 0 01.239-.24h3.521a.24.24 0 01.24.24v1.52a.24.24 0 01-.24.24"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
